export default "__VITE_ASSET__DBOMdMks__"